module.exports = __webpack_public_path__ + "static/media/defaultAvatar.5adaeb35.png";